import sieviApi from "@/api/sieviApi"
// export const myAction = async ( { commit } ) => {

// }

export const obtainContractsDocente = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/contratos/${id}`)
        if (data.ok) {
            commit('setContracts', data.contratos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainContractsAdministrador = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/contrato/${id}`)
        if (data.ok) {
            commit('setContracts', data.contratos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const activateContract = async ( { commit }, idContrato ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/contrato/activar/${idContrato}`)
        if (data.ok) {
            commit('activeContract', data.contrato)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deactivateContract = async ( { commit }, idContrato ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/contrato/desactivar/${idContrato}`)
        if (data.ok) {
            commit('deactivateContract', data.contrato)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainTypeContracts = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/contratos/tipos`)
        if (data.ok) {
            commit('setTypeContracts', data.tipoContrato)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainPeriods = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/contrato/periodos/${id}`)
        if (data.ok) {
            commit('setPeriods', data.periodos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createContract = async ( _, { form }) => {
    try {
        const periodo = []
        form.periodos.forEach(period => {
            periodo.push({
                campus_id: period.campus_id,
                nombre: period.nombre,
                numHoras: period.numHoraDocente,
                horario: period.horario !== null ? period.horario : null,
                contrato: period.contrato !== null ? period.contrato : null,
                estado: period.estado,
                numSemanas: period.numSemanas,
                principal: period.principal,
                fechaInicial: period.fechaInicial !== null ? period.fechaInicial.getFullYear()+"-"+(period.fechaInicial.getMonth()+1)+"-"+period.fechaInicial.getDate() : null,
                fechaFinal: period.fechaFinal ? period.fechaFinal.getFullYear()+"-"+(period.fechaFinal.getMonth()+1)+"-"+period.fechaFinal.getDate() : null,
                created: period.created,
                id: period.id
            })
        });
        const formData = new FormData();
        formData.append("fechaInicial", form.fechaInicial.getFullYear()+"-"+(form.fechaInicial.getMonth()+1)+"-"+form.fechaInicial.getDate())
        formData.append("fechaFinal", form.fechaFinal.getFullYear()+"-"+(form.fechaFinal.getMonth()+1)+"-"+form.fechaFinal.getDate())
        /* formData.append("horario", form.horario !== null ? form.horario[0] : null)
        formData.append("contrato", form.contrato !== null ? form.contrato[0] : null) */
        formData.append("tipoContrato_id", form.tipoContrato_id)
        formData.append("periodos", JSON.stringify(periodo))
        form.periodos.forEach(period => {
            formData.append(`horario_${period.id}`, period.horario !== null ? period.horario : null)
            formData.append(`contrato_${period.id}`, period.contrato !== null ? period.contrato : null)
        });

        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/usuarios/contrato/${form.id}`, formData)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const editContract = async ( _, { form }) => {
    try {
        const periodo = []
        form.periodos.forEach(period => {
            period.fechaInicial = new Date(period.fechaInicial)
            period.fechaFinal = new Date(period.fechaFinal)
            periodo.push({
                campus_id: period.campus_id,
                nombre: period.nombre,
                numHoras: period.numHoras,
                horario: period.horario !== null ? period.horario : null,
                contrato: period.contrato !== null ? period.contrato : null,
                estado: period.estado,
                numSemanas: period.numSemanas,
                principal: period.principal,
                fechaInicial: period.fechaInicial !== null ? period.fechaInicial.getFullYear()+"-"+(period.fechaInicial.getMonth()+1)+"-"+period.fechaInicial.getDate() : null,
                fechaFinal: period.fechaFinal ? period.fechaFinal.getFullYear()+"-"+(period.fechaFinal.getMonth()+1)+"-"+period.fechaFinal.getDate() : null,
                created: period.created,
                id: period.id
            })
        });
        const formData = new FormData();
        formData.append("fechaInicial", form.fechaInicial.getFullYear()+"-"+(form.fechaInicial.getMonth()+1)+"-"+form.fechaInicial.getDate())
        formData.append("fechaFinal", form.fechaFinal.getFullYear()+"-"+(form.fechaFinal.getMonth()+1)+"-"+form.fechaFinal.getDate())
        /* formData.append("horario", form.files.horario == null ? ((form.horario == null) ? '' : form.horario[0]) : form.files.horario)
        formData.append("contrato", form.files.contrato == null ? ((form.contrato == null) ? '' : form.contrato[0]) : form.files.contrato) */
        formData.append("tipoContrato_id", form.tipoContrato_id)
        /* formData.append("periodo_id", form.periodo_id) */
        formData.append("user_id", form.user_id)
        formData.append("periodos", JSON.stringify(periodo))
        form.periodos.forEach(period => {
            formData.append(`horario_${period.id}`, period.horario !== null ? period.horario : null)
            formData.append(`contrato_${period.id}`, period.contrato !== null ? period.contrato : null)
        });

        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/usuarios/contrato/editar/${form.id}`, formData)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainContractsResponsable = async ( { commit }, { id, campusId, hfsId, programId, teacherId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/contratos/${id}/${campusId}/${hfsId}/${programId}/${teacherId}`)
        if (data.ok) {
            commit('setContracts', data.contratos)
            return { ok: true, message: data.message }
        } else {
            commit('setContracts', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainContractsAuditor = async ( { commit }, { campusId, programId, teacherId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/contratos/${campusId}/${programId}/${teacherId}`)
        if (data.ok) {
            commit('setContracts', data.contratos)
            return { ok: true, message: data.message }
        } else {
            commit('setContracts', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}